import * as api from "@hp/api-client";
import type { AlertSettings, UpdateAlertSettingsRequest } from "@hp/api-client";
import { USE_MOCK_DATA } from "./config";

function delay<T>(value: T, ms = 300): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}

const MOCK_ALERT_SETTINGS: AlertSettings = {
  threshold_cr: 50,
  urgent_channel: "email",
  digest_frequency: "weekly",
  updated_at: "2026-09-01T10:00:00Z",
  updated_by_email: "admin@hindustanpower.com",
  show_true_up_gaps: false,
  show_event_search: true,
  show_top_reviewers: true,
  show_confidence_info: false,
  regulation_home: true,
  hide_no_hp_order_events: true,
  lookup_temperature: 0.7,
  show_genie_feedback: false,
  answer_shape: "env",
  answer_cache: "env",
  research_mode: "env",
  meaning_search: "env",
};

export async function getAlertSettings(): Promise<AlertSettings> {
  if (!USE_MOCK_DATA) return api.getAlertSettings();
  return delay({ ...MOCK_ALERT_SETTINGS });
}

export async function updateAlertSettings(request: UpdateAlertSettingsRequest): Promise<AlertSettings> {
  if (!USE_MOCK_DATA) return api.updateAlertSettings(request);
  return delay({
    ...MOCK_ALERT_SETTINGS,
    ...request,
    updated_at: new Date().toISOString(),
    updated_by_email: "you@hindustanpower.com",
  });
}
